<template>
  <div>
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <h5 v-if="formType == 'edit'" class="form-header">
              Editar {{ '' }} {{ oldName }}
            </h5>
            <h5 v-else class="form-header">Adicionar {{ '' }}</h5>
          </div>
          <div class="col-xs-12 pl-3 pr-3">
            <b-form-text id="nameInput">Nome *</b-form-text>
            <b-form-input
              v-model="form.NAME"
              placeholder="Informe o nome"
              maxlength="24"
              size="sm"
              type="text"
              aria-describedby="nameInput nameInputLiveFeedback"
              id="nameInput"
              :state="nameState && notRepeatedName"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório. Permitidos apenas letras, números, pontos, hífens e
              underlines.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>


            <b-form-text id="laminaInput">Lâmina de Transplantio (mm) *</b-form-text>
            <b-form-input
              v-model="form.LAMINA"
              placeholder="Informe o valor da lâmina de transplantio"
              maxlength="24"
              size="sm"
              type="number"
              :formatter="notEmpty"
              aria-describedby="laminaInput dapInputLiveFeedback"
              id="laminaInput"
              :state="laminaState"
            >
            </b-form-input>
            <b-form-text id="noteInput">Anotação</b-form-text>
            <b-form-input
              v-model="form.NOTE"
              placeholder=""
              maxlength="60"
              size="sm"
              aria-describedby="noteInput wiltPointInputLiveFeedback"
              id="noteInput"
            >
            </b-form-input>
          </div>
        </b-form>
      </div>
      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="$refs.formError.hide"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2 d-flex">
        <b-btn size="sm" variant="outline-secondary" @click="$emit('close-form')" class="ml-2 mr-1 w-100"> Cancelar </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="ml-1 mr-2  w-100"> Salvar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  testName,
  notEmpty,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
import { farmUseCase } from "@/api/modules/farm/useCases";
import managementSectorsActions from "@/mixins/managementSectorActions.js";

import {cookies} from "../../../components/cookies";

export default {
  name: "actuator-form",
  mixins: [managementSectorsActions],
  props: {
    // alreadyUsedNames: [Number, Array],
    items: {
      required: false,
      default: () => []
    },
    formType: String,
    itemToEdit: [Number, Object],
  },
  data() {
    return {
      errors: [],
      form: {
        ID:null,
        NAME:'',
        LAMINA:'',
        NOTE:"",
        FK_EDITOR:null
      },
    };
  },
  computed: {
    idItem() {
      return this.itemToEdit ? this.itemToEdit.ID : null;
    },
    notRepeatedName() {
      const currentName = this.form.NAME || '';
      const alreadyUsedNames = this.items.filter(val => val.ID !== this.idItem)
        .map(val => val.NAME);

      return currentName.length && !alreadyUsedNames.find(name => name === currentName);
    },
    nameState() {
      return testName(this.form.NAME);
    },
    oldName() {
      return this.itemToEdit && this.itemToEdit.NAME;
    },
    laminaState(){
      return this.form.LAMINA>0
    }
  },
  created() {
    if (this.formType == "add") this.resetForm();
    else {
      this.form.ID = this.itemToEdit.ID;
      this.form.NAME = this.itemToEdit.NAME;
      this.form.LAMINA = this.itemToEdit.LAMINA;
      this.form.NOTE = this.itemToEdit.NOTE;
      this.form.WILT_POINT = this.itemToEdit.WILT_POINT*100;
    }
  },
  methods: {
    makeAlert(ret) {
      if (ret) {
        alert(ret.log, ret.alert)
      } else {
        alert('Falha ao salvar dados', 'e')
      };
    },
    async submit(data) {
        // farmService[this.formType]
      const {
        idItem,
        formType
      } = this;
      await farmUseCase()
        [this.formType].execute(data)
        .then(async (resp) => {
          // resp[0] == [] => erro na inserção
          if (!resp[0]) {
            this.makeAlert({
              alert: "e",
              log: "Erro ao tentar inserir dados do cultivar",
            });
          } else {
            this.makeAlert({
              alert: "s",
              log: "Cadastro de cultivar realizado com sucesso",
            });

            await this.updateFarmEditorRefact({
              name: data.NAME,
              fkEditor: data.FK_EDITOR,
              idItem,
              formType
            });
          }
        })
        .catch((err) => {
          console.error("[SUBMIT FARM] - ", err);
          this.makeAlert({
            alert: "e",
            log: err,
          });
        });

      this.$emit('get-data-again');
      this.$emit('close-form');
    },
    notEmpty(value) {
      return notEmpty(value);
    },
    resetForm() {
      this.form = {
        ID:null,
        NAME:'',
        LAMINA:'',
        NOTE:"",
        FK_EDITOR:null
      };
    },
    checkForm() {
      this.errors = [];

      for (let key of Object.keys(this.form)) {
        if (this.form[key] == "") this.form[key] = null;
      }

      let states = [this.nameState, this.notRepeatedName, this.laminaState];
      let erros = [
        "Nome é obrigatório.",
        "O nome escolhido já está em uso.",
        "Lâmina é obrigatório e só aceita números.",
      ];

      states.map((e, i) => {
          if (!e) this.errors.push(erros[i]);
      });
      if (this.errors.length) this.$refs.formError.show();
      else{
        this.form.FK_EDITOR = Number(cookies.get('ID'))
        this.submit(this.form);
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .container-form{
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0;
    margin-right: 0;
  }
  #form, #details {
    padding-top: 1em;
    /* padding-top: 80px; */
}
}
</style>
